import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.podeConsultar ? _c('div', {
    staticClass: "estoque-grupo-produto"
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-primary btn-sm d-inline-flex align-items-center",
    attrs: {
      "type": "button",
      "aria-label": "Consultar estoque nas empresas",
      "title": "Consultar estoque nas empresas (F9)"
    },
    on: {
      "click": _vm.abrir
    }
  }, [_c('Magnify', {
    attrs: {
      "size": 18
    }
  }), _c('span', {
    staticClass: "ml-2 font-size-xs font-weight-bolder"
  }, [_vm._v("– F9")])], 1), _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "Estoque do produto nas empresas",
      "hide-footer": "",
      "scrollable": "",
      "hide-header-close": false,
      "no-close-on-esc": false,
      "modal-class": "estoque-grupo-modal",
      "dialog-class": "estoque-grupo-dialog",
      "content-class": "estoque-grupo-conteudo"
    },
    on: {
      "hidden": _vm.limparPesquisa
    }
  }, [_vm.carregando ? _c('div', {
    staticClass: "text-center py-12"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('div', {
    staticClass: "text-muted mt-3"
  }, [_vm._v("Consultando os estoques...")])], 1) : _vm.erroConsulta ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "light-danger"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.erroConsulta))]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.consultar
    }
  }, [_vm._v(" Tentar novamente ")])], 1)]) : _vm.consulta ? [_c('div', {
    staticClass: "produto-resumo rounded p-4 mb-5"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Produto selecionado")]), _c('strong', [_vm._v(" " + _vm._s(_vm.consulta.produto_origem.codigo) + " - " + _vm._s(_vm.consulta.produto_origem.descricao) + " ")]), _c('div', {
    staticClass: "text-muted font-size-sm mt-1"
  }, [_vm._v(" A consulta é somente leitura e não transfere estoque entre empresas. ")])]), _c('div', {
    staticClass: "table-responsive border rounded"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empresa")]), _c('th', [_vm._v("Produto localizado")]), _c('th', [_vm._v("Código de barras")]), _c('th', [_vm._v("Referência")]), _c('th', [_vm._v("Marca")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Estoque")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Reservado")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Disponível")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ação")])])]), _c('tbody', _vm._l(_vm.consulta.empresas, function (item) {
    return _c('tr', {
      key: item.empresa.id_empresa
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(item.empresa.nome))]), _c('div', {
      staticClass: "mt-1"
    }, [_c('span', {
      staticClass: "label label-inline",
      class: _vm.classeStatus(item.status)
    }, [_vm._v(" " + _vm._s(_vm.textoStatus(item)) + " ")])])]), _c('td', [item.produto ? [_c('strong', [_vm._v(_vm._s(item.produto.codigo))]), _vm._v(" - " + _vm._s(item.produto.descricao) + " ")] : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Nenhum produto relacionado")])], 2), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(item.produto && item.produto.cod_barras ? item.produto.cod_barras : "—") + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(item.produto && item.produto.referencia ? item.produto.referencia : "—") + " ")]), _c('td', [_vm._v(" " + _vm._s(item.produto && item.produto.marca ? item.produto.marca : "—") + " ")]), _c('td', {
      staticClass: "text-right font-weight-bold"
    }, [_vm._v(" " + _vm._s(item.produto ? _vm.formatarQuantidade(item.produto.estoque) : "—") + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(item.produto ? _vm.formatarQuantidade(item.produto.reservado) : "—") + " ")]), _c('td', {
      staticClass: "text-right font-weight-bolder",
      class: _vm.classeDisponivel(item.produto)
    }, [_vm._v(" " + _vm._s(item.produto ? _vm.formatarQuantidade(item.produto.disponivel) : "—") + " ")]), _c('td', {
      staticClass: "text-right text-nowrap"
    }, [item.status !== 'ORIGEM' ? _c('button', {
      staticClass: "btn btn-light-primary btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.iniciarPesquisa(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.status === "VINCULADO" ? "Alterar vínculo" : "Pesquisar produto") + " ")]) : _vm._e()])]);
  }), 0)])]), _vm.empresaPesquisa ? _c('div', {
    staticClass: "pesquisa-avancada border rounded p-5 mt-5"
  }, [_c('div', {
    staticClass: "d-flex align-items-start justify-content-between mb-4"
  }, [_c('div', [_c('strong', [_vm._v("Pesquisar em " + _vm._s(_vm.empresaPesquisa.empresa.nome))]), _c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Localize por código, código de barras, referência ou descrição. ")])]), _c('button', {
    staticClass: "btn btn-icon btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparPesquisa
    }
  }, [_vm._v(" × ")])]), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Digite ao menos 2 caracteres"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.pesquisar.apply(null, arguments);
      }
    },
    model: {
      value: _vm.termoPesquisa,
      callback: function callback($$v) {
        _vm.termoPesquisa = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "termoPesquisa"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.termoPesquisa.length < 2 || _vm.pesquisando
    },
    on: {
      "click": _vm.pesquisar
    }
  }, [_vm._v(" " + _vm._s(_vm.pesquisando ? "Buscando..." : "Buscar") + " ")])], 1)], 1), _vm.pesquisaExecutada ? _c('div', {
    staticClass: "mt-4"
  }, [!_vm.resultados.length ? _c('div', {
    staticClass: "text-muted text-center py-5"
  }, [_vm._v(" Nenhum produto encontrado nesta empresa. ")]) : _c('div', {
    staticClass: "resultados-pesquisa"
  }, _vm._l(_vm.resultados, function (resultado) {
    return _c('div', {
      key: resultado.id,
      staticClass: "resultado-item d-flex align-items-center justify-content-between border rounded p-3 mb-2"
    }, [_c('div', {
      staticClass: "mr-4"
    }, [_c('strong', [_vm._v(_vm._s(resultado.codigo) + " - " + _vm._s(resultado.descricao))]), _c('div', {
      staticClass: "text-muted font-size-sm"
    }, [resultado.referencia ? _c('span', [_vm._v("Ref.: " + _vm._s(resultado.referencia) + " · ")]) : _vm._e(), _vm._v(" Disponível: " + _vm._s(_vm.formatarQuantidade(resultado.disponivel)) + " ")])]), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.vinculando === resultado.id
      },
      on: {
        "click": function click($event) {
          return _vm.vincular(resultado);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.vinculando === resultado.id ? "Vinculando..." : "Vincular") + " ")])]);
  }), 0)]) : _vm._e()], 1) : _vm._e()] : _vm._e()], 2)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };